import { PAGE_NAV_TITLE, USERS_OVERVIEW_TITLE } from "components/users/bindings";
import TeamsOverviewPage from "./pages/TeamsOverviewPage";
import TeamDetailsPage from "./pages/TeamDetailsPage";
import TeamEditPage from "./pages/TeamEditPage";
import TeamCreatePage from "./pages/TeamCreatePage";
import UserTeamsAssignment from "./components/user/UserTeamsAssignment";
import RoleTeamsAssignment from "./components/roles/RoleTeamsAssignment";
import useTeamMembersByRole from "./logic/useTeamMembersByRole";
import SecurityRoutes from "./Routes";
const teams = {
  useTeamMembersByRole,
  UserTeamsAssignment,
  RoleTeamsAssignment
};
const bindings = {
  teams,
  routes: [
    { path: SecurityRoutes.unqualified.TEAMS.OVERVIEW, component: TeamsOverviewPage, permissions: "team:read" },
    { path: SecurityRoutes.unqualified.TEAMS.CREATE, component: TeamCreatePage, permissions: "team:create" },
    { path: SecurityRoutes.unqualified.TEAMS.DETAILS(":teamId"), component: TeamDetailsPage, permissions: "team:read" },
    { path: SecurityRoutes.unqualified.TEAMS.EDIT(":teamId"), component: TeamEditPage, permissions: "team:read" }
  ],
  pageNavigation: [
    {
      description: PAGE_NAV_TITLE,
      children: [
        {
          description: "Teams Overview",
          titleKey: "enterprise_navigation:users.teams_overview",
          path: SecurityRoutes.TEAMS.OVERVIEW,
          position: { after: USERS_OVERVIEW_TITLE }
        }
      ]
    }
  ],
  entityTypeRoute: [
    {
      type: "team",
      route: (id) => SecurityRoutes.TEAMS.DETAILS(id)
    },
    {
      type: "team_users",
      route: (id) => SecurityRoutes.TEAMS.DETAILS(id)
    }
  ],
  entityCreators: [
    {
      id: "Team",
      title: "Create team",
      path: SecurityRoutes.TEAMS.CREATE,
      permissions: "team:create"
    }
  ]
};
export default bindings;
